const COLUMNS_DOCS = ['Name', 'Dataset', 'Upload Date', 'Status', 'Uploader', ''];
const COLUMNS_TEMPLATES = ['Name', 'Dataset', 'Create Date', 'Created By', ''];

export { COLUMNS_DOCS, COLUMNS_TEMPLATES };
